<section class="xl:container xl:m-auto xl:pl-[15px] xl:pr-[15px]" id="aboutauthor">
    <div class="p-6 md:px-[70px] md:py-12 bgbanner bg-cover bg-center bg-[#F5F1F1]">
        <h3 class="text-32 text-black font-libre-regular mb-6">
            About the Author
        </h3>
        <div class="flex mb-6">
            <div>
                <h4 class="text-18 text-black mb-[6px]">Puneet Asthana</h4>
                <p class="text-14 text-[#666666] mb-0">
                    Executive Director & Chief Technology Officer
                </p>
            </div>
        </div>
        <div class="editor-content">
            <p>
                Puneet has over <b>24 years of experience</b> and has worked with <b>HDFC Securities, Reliance Group,
                    FCS
                    Software
                    Solutions,</b> and various other organizations.
                He was most recently associated with <b>ICICI Securities</b> as a <b>Senior Vice President</b>, heading
                their Technology
                Solutions & Operations.
            </p>
        </div>

    </div>
</section>